export const TOTAL_SLIDES = 8;

// ─── Mobile carousel slot positions ───
// Each slot describes where an image sits (left, bottom, size, visual effects).
// The carousel always renders 5 slots: off-screen-left, left, center, right, off-screen-right.

export const MOBILE_SLOTS = {
    OUT_LEFT:  { left: -250,    bottom: 0, width: 295.698, height: 295.698, opacity: 0,    filter: "blur(6px)", zIndex: 1,  y: -90 },
    LEFT:      { left: 69,      bottom: 0, width: 295.698, height: 295.698, opacity: 0.45, filter: "blur(4px)", zIndex: 2,  y: -90 },
    CENTER:    { left: 233.698, bottom: 0, width: 393,     height: 340,     opacity: 1,    filter: "blur(0px)", zIndex: 10, y: 0   },
    RIGHT:     { left: 495.698, bottom: 0, width: 295.698, height: 295.698, opacity: 0.45, filter: "blur(4px)", zIndex: 2,  y: -90 },
    OUT_RIGHT: { left: 900,     bottom: 0, width: 295.698, height: 295.698, opacity: 0,    filter: "blur(6px)", zIndex: 1,  y: -90 },
};

// Order matters: index 0 = off-left, 1 = left, 2 = center, 3 = right, 4 = off-right
export const MOBILE_SLOT_ORDER = [
    MOBILE_SLOTS.OUT_LEFT,
    MOBILE_SLOTS.LEFT,
    MOBILE_SLOTS.CENTER,
    MOBILE_SLOTS.RIGHT,
    MOBILE_SLOTS.OUT_RIGHT,
];

// Each slot renders the slide at cur + offset
export const MOBILE_OFFSETS = [-2, -1, 0, 1, 2];

// When swiping NEXT (dir=1), each slot shifts one position to the left:
//   slot[1] → OUT_LEFT,  slot[2] → LEFT,  slot[3] → CENTER,  slot[4] → RIGHT
// When swiping PREV (dir=-1), each slot shifts one position to the right:
//   slot[0] → LEFT,  slot[1] → CENTER,  slot[2] → RIGHT,  slot[3] → OUT_RIGHT
export const MOBILE_NEXT_MOVES = [
    { slotIndex: 1, target: "OUT_LEFT"  },
    { slotIndex: 2, target: "LEFT"      },
    { slotIndex: 3, target: "CENTER"    },
    { slotIndex: 4, target: "RIGHT"     },
];

export const MOBILE_PREV_MOVES = [
    { slotIndex: 0, target: "LEFT"      },
    { slotIndex: 1, target: "CENTER"    },
    { slotIndex: 2, target: "RIGHT"     },
    { slotIndex: 3, target: "OUT_RIGHT" },
];

export const SWIPE_THRESHOLD = 45;
export const AUTOPLAY_INTERVAL = 2000;

// ─── Slide data ───

export const SLIDES = [
    {
        year: "2017",
        title: "The Start",
        imgAlt: "NowPurchase journey - The Start",
        description:
            "Founded by Naman & Aakash, NowPurchase began as a B2B platform with 40,000+ SKUs and 10,000+ orders, uncovering key gaps in metal sourcing.",
        imgSrc: "/history/1.png",
    },
    {
        year: "2020",
        title: "Staying Strong",
        imgAlt: "NowPurchase journey - Staying Strong",
        description:
            "During COVID, NowPurchase shifted to a foundry-focused model, ensured zero layoffs, supported customers with fair pricing, and welcomed Ankan Adhikari as CTO.",
        imgSrc: "/history/2.png",
    },
    {
        year: "2021",
        title: "Strong Backing",
        imgAlt: "NowPurchase journey - Strong Backing",
        description:
            "Raised $2.4M from InfoEdge Ventures, Orios Venture Partners, and NIPHA, strengthening trust and long-term vision.",
        imgSrc: "/history/3.png",
    },
    {
        year: "2022",
        title: "Powering with Tech",
        imgAlt: "NowPurchase journey - Powering with Tech",
        description:
            "Launched MetalCloud to bring real-time updates and WhatsApp-based visibility to foundry operations.",
        imgSrc: "/history/4.png",
    },
    {
        year: "2023",
        title: "Scaling on Ground",
        imgAlt: "NowPurchase journey - Scaling on Ground",
        description:
            "Set up a 30,000 sq. ft. scrap processing center in West Bengal and expanded operations to Maharashtra.",
        imgSrc: "/history/5.png",
    },
    {
        year: "2024",
        title: "Building Momentum",
        imgAlt: "NowPurchase journey - Building Momentum",
        description:
            "Launched GraphiMax and CarbonMax, raised $6M to scale, and earned World Foundry Organization (WFO) recognition.",
        imgSrc: "/history/6.png",
    },
    {
        year: "2025",
        title: "Pan-India Reach",
        imgAlt: "NowPurchase journey - Pan-India Reach",
        description:
            "Expanded with a new Pune processing unit and introduced AI-driven foundry digitization.",
        imgSrc: "/history/7.png",
    },
    {
        year: "2026",
        title: "Beyond Borders",
        imgAlt: "NowPurchase journey - Beyond Borders",
        description:
            "Aiming to build a strong global presence for MetalCloud AI.",
        imgSrc: "/history/8.png",
    },
];


export const CARD_W = 575.69;
export const CARD_H = 601.03;



export const POS = [
  /* pos 0 */ { left: 1263.0, top: 319.0, width: 546.663, op: 1.0, bl: 0.0 },
  /* pos 1 */ { left: 950.0, top: 331.0, width: 431.768, op: 0.6, bl: 0.0 },
  /* pos 2 */ { left: 705.0, top: 338.0, width: 323.826, op: 0.4, bl: 1.0 },
  /* pos 3 */ { left: 520.0, top: 340.0, width: 242.87, op: 0.3, bl: 2.0 },
  /* pos 4 */ { left: 380.0, top: 337.0, width: 185.791, op: 0.3, bl: 3.0 },
  /* pos 5 */ { left: 276.0, top: 333.0, width: 139.343, op: 0.2, bl: 4.0 },
  /* pos 6 */ { left: 196.0, top: 327.0, width: 104.508, op: 0.2, bl: 5.0 },
  /* pos 7 */ { left: 130.0, top: 319.0, width: 78.381, op: 0.1, bl: 6.0 },
];


export const MOBILE_QUERY = "(max-width: 767px)";
export const DESIGN_W = 1920;
export const DESIGN_H = 1080;